import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {getValueHash} from '../../common/utils/array';
import _ from 'lodash';
import {
    setStatisticsStatus,
    resetStatisticsStatus,
    fetchStatisticsInfo,
    addStatisticsInfo,
    updStatisticsInfo,
    delStatisticsInfo,
    changeCurrentPath,
    resetMainListState,
    resetConsigneeListStateNew,
} from '../../actions';

import Select from '../../common/components/input/creatable-select';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';
import MainButtons from '../../common/components/main-buttons';
import AlertDialog from '../../common/components/dialog/alert-dialog';

import InnerForm from './components/inner-form';
import FormDialog from './components/form-dialog';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';

const styles = theme => ({
    conditionDivideSelect:{
        marginBottom:15,
        backgroundColor:'rgba(244, 236, 225, 0.5)',
        padding:'10px 20px',
        boxShadow:'0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)'
    },
    selectWrap:{
        flexBasis:'calc(100% - 285px)'
    },
    buttonWrap:{
        flexBasis:'285px',
        boxSizing:'border-box',
        paddingTop:15
    },
    button:{
        marginLeft:15
    },
    messageSpan:{
        display:'inline-block',
        marginTop:20,
        backgroundColor:'rgba(0,0,0,0.05)',
        padding: 10,
        borderRadius:4,
        fontSize:'90%',
        color:'#f90c0c'
    },
    selectCaution:{
        color:'rgba(0, 0, 0, 0.54)',
        fontSize:'0.8125rem'
    }
});


const initialCurrentFormState = {
    aggregates:[],
    conditions:[],
    outputs:[],
    conditionDate:{dateType:"0",from:null,to:null},
};

const initialDefaultValuesState = {
    value:null,
    label:null,
    disableUpdate:true,
    settingData:initialCurrentFormState
};


class Statistics extends Component {

    constructor(props) {
        super(props);
        const {defaultCurrentValues, currentFormValues, isUpdateValues} = props.settings;
        this.state = {
            dialogOpen:false,
            deleteDialogOpen:false,
            defaultCurrentValues:(defaultCurrentValues === undefined) ? initialDefaultValuesState : defaultCurrentValues,
            currentFormValues:(currentFormValues === undefined) ? initialCurrentFormState : currentFormValues,
            isUpdateValues:(isUpdateValues === undefined) ? false : isUpdateValues,
            clearProcessName:null,
            afterSelectValue:{},
            inputErrorText:null,
            afterRedirectFunc : null
        };

        this.nextIsList = false;
    }
	/** override methods **/
    UNSAFE_componentWillMount() {
        const {dispatch} = this.props;
	    if(this.state.currentFormValues !== {}){
	        this.getStatisticsSettingInfo();
        }
	    dispatch(resetMainListState());
        dispatch(resetConsigneeListStateNew());

	}
    componentDidMount() {
        window.addEventListener("beforeunload", this.onUnloadEvent);
		const { dispatch, history } = this.props;
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}


    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.onUnloadEvent);
	    if(!this.nextIsList){
            this.props.dispatch(resetStatisticsStatus());
        }

    }


    /** event handlers **/
    handleClickClear = () =>{
        if(this.state.isUpdateValues){
            this.setState({
                clearProcessName:"CLEAR",
                dialogOpen:true,
            });
        }
        else{

            this.setState({
                defaultCurrentValues : initialDefaultValuesState,
                currentFormValues : initialCurrentFormState,
                isUpdateValues:false
            });
        }
    };

    doClear = () =>{
        const {clearProcessName, afterSelectValue} = this.state;
        switch(clearProcessName){
            case "INDEX_CHANGES":
                const defaultCurrentValues = getValueHash(afterSelectValue);
                const currentFormValues = getValueHash(defaultCurrentValues.settingData);
                this.setState({
                    defaultCurrentValues,
                    currentFormValues,
                    dialogOpen:false,
                    clearProcessName:null,
                    afterSelectValue:{},
                    isUpdateValues:false
                });
                break;
            case "REDIRECT":
                this.state.afterRedirectFunc();
                break;
            default:
                this.setState({
                    dialogOpen:false,
                    clearProcessName:null,
                    isUpdateValues:false,
                    defaultCurrentValues : initialDefaultValuesState,
                    currentFormValues : initialCurrentFormState,
                    afterSelectValue:{},
                    inputErrorText:null,
                    afterRedirectFunc : null
                });
                break;
        }
    };

    doSaveAndClear = (canOverride, name) =>{

        if(!canOverride || name !== ''){
            this.createOptions(name);
        }
        else{
            this.handleClickUpdate();
        }
        this.doClear();
    };

    cancelClear = () =>{
        this.setState({
            dialogOpen:false,
            clearProcessName:null,
            afterSelectValue:{},
            afterRedirectFunc:null
        });
    };

    handleClickCalc = () => {
        const {dispatch,history} = this.props;
        const {defaultCurrentValues, currentFormValues, isUpdateValues} = this.state;

        if(Object.keys(currentFormValues).length === 0){
            this.setState({
                inputErrorText:<span>「出力項目」は1つ以上選択してください。<br/>抽出条件「日付」は開始・終了共に必須入力です</span>
            });
            return;
        }


        if(currentFormValues.outputs.length === 0){
            this.setState({
                inputErrorText:<span>「出力項目」を1つ以上選択してください</span>
            });
            return;
        }

        if(!currentFormValues.conditionDate || currentFormValues.conditionDate.from === null || this.state.currentFormValues.conditionDate.to === null){
            this.setState({
                inputErrorText:<span>抽出条件「日付」は開始・終了共に必須入力です</span>
            });
            return;
        }


        const aggregates = _.map(currentFormValues.aggregates, (row) => {
            return row.value;
        });

        if(_.uniq(aggregates).length !== aggregates.length){
            this.setState({
                inputErrorText:<span>「集計項目」に重複した値が存在します</span>
            });
            return;
        }

        const conditions = _.filter(currentFormValues.conditions, (row) => {
            const keyword = !row.keyword ? null : row.keyword.trim();
            return (row.searchType === "1" && !row.from && !row.to) ||
                ((!row.searchType || row.searchType === "2") && !keyword);
        });

        if(conditions.length){
            this.setState({
                inputErrorText:<span>「抽出条件」の内容が設定されていません</span>
            });
            return;
        }


        this.nextIsList = true;

        dispatch(setStatisticsStatus({
            defaultCurrentValues,
            currentFormValues,
            isUpdateValues,
        }));
        history.push('/statistics-list');
    };

    handleChangeOptions = (data) =>{
        const defaultCurrentValues = getValueHash(data);

        if(this.state.isUpdateValues){
            this.setState({
                afterSelectValue:defaultCurrentValues,
                clearProcessName:"INDEX_CHANGES",
                dialogOpen:true,
            })
        }
        else{
            const currentFormValues = getValueHash(defaultCurrentValues.settingData);
            this.setState({
                defaultCurrentValues,
                currentFormValues
            });
        }

    };

    handleClickUpdate = () =>{
        const {dispatch,auth} = this.props;

        const targetID = this.state.defaultCurrentValues.value;

        dispatch(updStatisticsInfo({
            SessionID : auth.SessionID,
            updateData : this.state.currentFormValues,
            targetID
        }));

        let statisticsInfo = getValueHash(this.props.settings.statisticsInfo);
        const targetIndex = _.findIndex(statisticsInfo,['value',targetID]);
        let defaultCurrentValues = getValueHash(this.state.defaultCurrentValues);
        defaultCurrentValues.settingData = this.state.currentFormValues;
        statisticsInfo[targetIndex] = defaultCurrentValues;

        this.setState({
            defaultCurrentValues,
            isUpdateValues:false
        });

        dispatch(setStatisticsStatus({
            statisticsInfo
        }));
    };

    handleClickDelete = () =>{
        this.setState({
            dialogOpenDelete:true
        });
    };

    doDelete = () =>{
        this.setState({
            dialogOpenDelete:false
        });

        const {dispatch,auth} = this.props;
        const targetID = this.state.defaultCurrentValues.value;
        dispatch(delStatisticsInfo({
            SessionID : auth.SessionID,
            targetID
        }));

        let statisticsInfo = getValueHash(this.props.settings.statisticsInfo);
        const targetIndex = _.findIndex(statisticsInfo,['value',targetID]);
        statisticsInfo.splice(targetIndex,1);

        this.setState({
            defaultCurrentValues : initialDefaultValuesState,
            currentFormValues : initialCurrentFormState,
            isUpdateValues:false
        });

        dispatch(setStatisticsStatus({
            statisticsInfo
        }));


    };

    cancelDelete = () =>{
        this.setState({
            dialogOpenDelete:false
        });
    };

    handleUpdateForms = (dataSource)=>{
        this.setState({
            currentFormValues:getValueHash(dataSource),
            isUpdateValues:true
        });
    };

    handleCloseInputError = () =>{
        this.setState({
            inputErrorText:null
        });
    };


    /** Private Method **/
    getStatisticsSettingInfo = () =>{
        const { dispatch, auth } = this.props;
        dispatch(fetchStatisticsInfo({
            SessionID : auth.SessionID
        }));
    };

    createOptions = (createValue) =>{
        const {currentFormValues} = this.state;
        let newOptions = getValueHash(this.props.settings.statisticsInfo);
        const newOption = {
            value:'NEW',
            label:createValue,
            disableUpdate:false,
            settingData:getValueHash(currentFormValues)
        };
        newOptions.push(newOption);

        const {dispatch,auth} = this.props;
        dispatch(setStatisticsStatus({
            statisticsInfo:newOptions,
        }));

        this.setState({
            defaultCurrentValues:newOption,
            isUpdateValues:false
        });

        dispatch(addStatisticsInfo({
            SessionID : auth.SessionID,
            label:createValue,
            updateData : currentFormValues
        }));
    };

    onUnloadEvent = (event) =>{
        if(this.state.isUpdateValues){
            event.preventDefault();
            event.returnValue = '';
        }

    };

    redirectEvent = (event) =>{
        if(this.state.isUpdateValues){
            this.setState({
                afterRedirectFunc:event,
                clearProcessName:"REDIRECT",
                dialogOpen:true,
            });
        }
        else{
            event();
        }
    };


    render() {
        const {settings,classes,history} = this.props;
        const statisticsInfo = settings.statisticsInfo;
        const {dialogOpen, dialogOpenDelete, defaultCurrentValues, currentFormValues, inputErrorText} = this.state;

        const mainButtons = [
            {type:'CALC',func:this.handleClickCalc},
            {type:'CLEAR',func:this.handleClickClear},
        ];
        const disableUpdate = defaultCurrentValues.disableUpdate;

        return (
            <div id="main_container">
                {settings.isFetching &&
                <Progress/>
                }
                <SpNav history={history} redirectFunc={this.redirectEvent}/>
                <Header history={history} redirectFunc={this.redirectEvent}/>
                <article>
                    <section className="title_area">
                        <h2>統計情報</h2>
                    </section>
                    <section className="with_button">
                        <FormGroup row className={classes.conditionDivideSelect}>
                            <div className={classes.selectWrap}>
                                <Select
                                    inputLabel={"条件名"}
                                    suggestions={statisticsInfo}
                                    value={defaultCurrentValues}
                                    afterChangeFunction={this.handleChangeOptions}
                                    afterCreateFunction={this.createOptions}
                                    createTextPrefix={"条件"}

                                />
                            </div>
                            <div className={classes.buttonWrap}>
                                <Button variant="contained" color="primary" onClick={this.handleClickUpdate} size={"medium"} className={classes.button} disabled={disableUpdate}>
                                    保存
                                </Button>
                                <Button variant="contained" color="primary" onClick={this.handleClickDelete} size={"medium"} className={classes.button} disabled={disableUpdate}>
                                    条件の削除
                                </Button>
                            </div>
                            <div className={classes.selectCaution}>※条件名を選択してください。新規で条件を作成する場合はここに条件名を記入して下さい</div>
                        </FormGroup>
                        <InnerForm
                            aggregateSource={settings.aggregateDivide}
                            conditionSource={settings.conditionDivide}
                            outputItemSource={settings.outputItem}
                            dataSource={currentFormValues}
                            afterChangeFunction={this.handleUpdateForms}
                        />
                    </section>
                </article>
                <MainButtons buttons={mainButtons}/>
                <Footer/>
                <FormDialog
                    open={dialogOpen}
                    canOverride={!disableUpdate}
                    afterOkFunc={this.doSaveAndClear}
                    afterContinueFunc={this.doClear}
                    afterCancelFunc={this.cancelClear}
                />
                <AlertDialog
                    open={dialogOpenDelete}
                    title={"確認"}
                    text={<span>条件を削除します。よろしいですか？</span>}
                    okFunction={this.doDelete}
                    closeFunction={this.cancelDelete}
                />
                <ErrorDialog
                    open={settings.isProcessError}
                />
                <ErrorDialog
                    open={(inputErrorText !== null)}
                    title={'設定内容エラー'}
                    text={inputErrorText}
                    afterCloseFunc={this.handleCloseInputError}
                />
				<ReloadModal />
                <LogoutModal />

            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
	  navigation : state.navigation,
      auth: state.auth,
      settings : state.statisticsSettings,
  };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(Statistics);



// WEBPACK FOOTER //
// ./src/routes/statistics/index.js